import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchInventoryIntraBranchList = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        return false
    } else {
        axios.post('/inventoryIntraBranch/index.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {
            
            if(res.data.try_again) {
                dispatch('fetchInventoryIntraBranchList', payload)
            } else {
                commit('setInventoryIntraBranchList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number})
            }
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
}

export const fetchInventoryIntraBranchData = ({commit}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/inventoryIntraBranch/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            
            commit('setInventoryIntraBranchData', {response: res.data.response, copy: payload.copy})   
            
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }
        } else {
            commit('resetInventoryIntraBranchData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitInventoryIntraBranchData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/inventoryIntraBranch/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {        

        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            dispatch('fetchInventoryIntraBranchData', {id: res.data.id})                    
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
        dispatch('fetchInventoryIntraBranchData', {id: payload.id})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteInventoryIntraBranchData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/inventoryIntraBranch/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchInventoryIntraBranchList', payload.list)
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryIntraBranch/actions.js